import { TableFiltersBar } from '@/common/pages/accountEdit/networkProtectionV2/components';
import { monitoringObjectsFiltersConfig } from '@/common/pages/accountEdit/networkProtectionV2/utils/tableFilters';
import { DATE_FORMAT_DEFAULT, OrderTypes } from '@/constants';
import { getFullDateFromISO } from '@/utils';
import { Box, Table } from '@servicepipe/ui-components';
import React from 'react';

export const MonitoringObjectsTable = ({
  data,
  onPageChange,
  queryParams,
  totalPages,
  totalCount,
  onSortingChange,
  onFiltersChange,
  loading,
}) => {
  const sortingInitial = {
    id: queryParams.sortKey || '',
    desc: queryParams.sortDirection === OrderTypes.Desc,
  };

  const columns = [
    {
      width: 110,
      minWidth: 110,
      enableSorting: true,
      header: 'ID',
      id: 'id',
      body: 'id',
    },
    {
      header: 'Client name',
      id: 'name',
      minWidth: 160,
      width: 160,
      body: 'name',
    },
    {
      header: 'FlowCollector MO name',
      id: 'monitoringObjectName',
      minWidth: 200,
      width: 200,
      body: 'monitoringObjectName',
    },
    {
      header: 'Description',
      id: 'description',
      minWidth: 200,
      width: 200,
      body: 'description',
    },
    {
      header: 'Destination IP',
      id: 'ips',
      minWidth: 160,
      width: 160,
      body: ({ getValue }) => {
        const ips = getValue();
        return Array.isArray(ips)
          ? ips.map((ip, index) => (
              <React.Fragment key={index}>
                {ip}
                {index < ips.length - 1 && <br />}
              </React.Fragment>
            ))
          : ips;
      },
    },
    {
      enableSorting: true,
      header: 'Created at',
      id: 'createdAt',
      minWidth: 160,
      width: 160,
      body: ({ getValue }) => getFullDateFromISO(getValue(), DATE_FORMAT_DEFAULT),
    },
  ];

  return (
    <Box direction="column" width="100%" minWidth="0">
      <TableFiltersBar
        filtersConfig={monitoringObjectsFiltersConfig}
        queryFilters={queryParams.filters ?? []}
        onFiltersChange={onFiltersChange}
      />

      <Table
        loading={loading}
        data={data}
        totalCount={totalCount}
        columns={columns}
        page={queryParams.page}
        size={queryParams.pageSize}
        totalPages={totalPages}
        onPageChange={onPageChange}
        onSortingChange={onSortingChange}
        initialStateSort={sortingInitial}
        isFixedLayout
      />
    </Box>
  );
};
